/* eslint-disable jsx-a11y/alt-text */
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper/modules";
import Parentheses from "../components/parentheses";
import { mousewheel } from "../App";

const Section10 = ({ isActive = false, onSlideChange }) => {
  return (
    <Swiper
      className="action_box"
      direction="vertical"
      speed={700}
      mousewheel={mousewheel}
      nested
      preventInteractionOnTransition
      modules={[Mousewheel]}
      onSlideChange={onSlideChange}
    >
      <SwiperSlide>
        <div className="bg_wrap">
          <picture className="section_bg">
            <source
              srcSet="//www.locknlock.com/eng/image/common/about/brand/image_action_1_pc.png"
              media="(min-width: 768px)"
            />
            <img src="//www.locknlock.com/eng/image/common/about/brand/image_action_1_mob.png" />
          </picture>
          <Parentheses isActive={isActive} index={1} />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="bg_wrap">
          <picture className="section_bg">
            <source
              srcSet="//www.locknlock.com/eng/image/common/about/brand/image_action_2_pc.png"
              media="(min-width: 768px)"
            />
            <img src="//www.locknlock.com/eng/image/common/about/brand/image_action_2_mob.png" />
          </picture>
          <Parentheses isActive={isActive} index={2} />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="bg_wrap">
          <picture className="section_bg">
            <source
              srcSet="//www.locknlock.com/eng/image/common/about/brand/image_action_3_pc.png"
              media="(min-width: 768px)"
            />
            <img src="//www.locknlock.com/eng/image/common/about/brand/image_action_3_mob.png" />
          </picture>
          <Parentheses isActive={isActive} index={3} />
        </div>
      </SwiperSlide>
    </Swiper>
  );
};

export default Section10;
